import React from "react";

const RefreshIcon = ({ size = 80, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 80 80"
    fill="none"
    {...props}
  >
    <path
      d="M39.9993 73.3327C58.4088 73.3327 73.3327 58.4088 73.3327 39.9993C73.3327 21.5899 58.4088 6.66602 39.9993 6.66602C21.5899 6.66602 6.66602 21.5899 6.66602 39.9993C6.66602 58.4088 21.5899 73.3327 39.9993 73.3327Z"
      stroke="#F23F3F"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.6992 48.3658C27.2992 49.3658 28.0325 50.2992 28.8659 51.1326C34.9992 57.2659 44.9658 57.2659 51.1325 51.1326C53.6325 48.6326 55.0659 45.4658 55.5325 42.2324"
      stroke="#F23F3F"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.4668 37.7658C24.9335 34.4991 26.3668 31.3656 28.8668 28.8656C35.0002 22.7323 44.9668 22.7323 51.1335 28.8656C52.0001 29.7323 52.7001 30.6657 53.3001 31.6323"
      stroke="#F23F3F"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.0664 57.2652V48.3652H34.9663"
      stroke="#F23F3F"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M53.9331 22.7324V31.6324H45.0332"
      stroke="#F23F3F"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default RefreshIcon;
